import React, { useEffect } from "react";
import welcomeBack from "assets/images/welcome.png";
import { Link, useNavigate } from "react-router-dom";
import { useLogin } from "utils/api/auth.api";
import { type UserLogin } from "utils/types/user.type";
import { type SubmitHandler, useForm } from "react-hook-form";
import toast from "react-hot-toast";
import { Input } from "components/input";
import Logo from "../../assets/icons/logo.svg";
import { getTokenAndSendToBackend } from "utils/firebase";

// import WalletIcon from "assets/images/WalletIcon.svg";

export default function Login() {
  const navigate = useNavigate();

  const { mutate: userLogin, isSuccess, data, isLoading } = useLogin();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<UserLogin>();

  const onSubmit: SubmitHandler<UserLogin> = (data) => userLogin(data);

  useEffect(() => {
    if (isSuccess) {
      if (data?.user?.isAdmin) {
        localStorage.setItem("token", data?.token?.access_token?.split(" ")[1]);
        localStorage.setItem("userRole", data?.user?.role);
        toast.success("Login successfully!");
        getTokenAndSendToBackend()
          .then(() => {
            console.log("FCM token sent to backend successfully.");
          })
          .catch((error) => {
            console.error("Error sending FCM token to backend:", error);
          });
        navigate("/pending-withdrawals");
      } else {
        toast.error("Only admins can login!");
      }
    }
  }, [isSuccess]);
  return (
    <section className="login-section h-screen overflow-hidden">
      <div className="flex flex-col h-full ">
        <header
          style={{
            paddingTop: "30px",
            paddingBottom: "0px",
            paddingLeft: "30px",

            display: "flex",
            alignItems: "center",
            gap: "16px",
          }}
        >
          {" "}
          <img style={{ height: "50px" }} src={Logo} alt="" />{" "}
          {/* <span className="text-black text-xl  whitespace-nowrap">
            Paysela
          </span> */}
        </header>
        <div
          className="grid lg:grid-cols-12 items-center h-screen gap-3"
          style={{ height: "maxContent" }}
        >
          <div className="lg:col-span-6 flex items-center justify-center">
            <div
              className="login-wrapper w-full max-w-md  p-6"
              style={{ height: "100%" }}
            >
              <h5 className="text-black-800 text-[32px] font-[700] mb-8 xl:mb-10 font-[Poppins]">
                WELCOME BACK
              </h5>
              {/* eslint-disable-next-line @typescript-eslint/no-misused-promises  */}
              <form onSubmit={handleSubmit(onSubmit)}>
                <div className="mb-4">
                  <Input
                    isInvalid={Boolean(errors?.email)}
                    errorMessage={errors?.email?.message}
                    label="Email"
                    placeholder=""
                    type="email"
                    name="email"
                    register={register}
                    rules={{
                      required: "Email is required",
                    }}
                  />
                </div>

                <div className="mb-4">
                  <Input
                    isInvalid={Boolean(errors?.password)}
                    errorMessage={errors?.password?.message}
                    label="Password"
                    type="password"
                    placeholder="********"
                    name="password"
                    register={register}
                    rules={{
                      required: "Password is required",
                    }}
                  />
                </div>

                <div className="mb-4 lg:mb-14">
                  <div className="text-right">
                    <Link to="/forgot-password">
                      <b>Forgot Password?</b>
                    </Link>
                  </div>
                </div>

                <button
                  type="submit"
                  className="bg-cyan-800 hover:bg-cyan-300  hover:text-cyan-800 text-white text-x font-medium border border-cyan-800 rounded-lg w-full px-4 py-3 transition whitespace-nowrap "
                  disabled={isLoading}
                >
                  {isLoading ? (
                    <div
                      className="w-8 h-8 rounded-full animate-spin mx-auto
                      border-4 border-solid border-cyan-800 border-t-transparent"
                    ></div>
                  ) : (
                    "LOGIN TO YOUR ACCOUNT"
                  )}
                </button>

                <div className="text-center" style={{ padding: "20px" }}>
                  <Link
                    to="/signup"
                    className="text-cyan-800 text-x font-heavy whitespace-nowrap"
                  >
                    Create an account instead?
                  </Link>
                </div>
              </form>
            </div>
          </div>
          <div className="lg:col-span-6 relative lg:overflow-hidden">
            <div className="login-bg h-full flex items-center justify-center">
              <img
                className="max-w-xs lg:max-w-none object-contain"
                style={{ height: "680px" }}
                src={welcomeBack}
                alt="title"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
